// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();

//     this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
//     this.searchInput = this.querySelector('input[name="country_filter"]');
//     this.resetButton = this.querySelector('.country-filter-reset-button');
//     this.searchIcon = this.querySelector('.country-filter-search-icon');

//     this.initEvents();
//   }

//   initEvents() {
//     if (this.searchInput) {
//       this.searchInput.addEventListener('input', () => this.findCountrie());
//       this.searchInput.addEventListener('keydown', (e) => this.preventEnterSubmit(e));
//     }

//     if (this.resetButton) {
//       this.resetButton.addEventListener('click', (e) => this.resetFilter(e));
//       this.resetButton.addEventListener('mousedown', (e) => e.preventDefault());
//     }

//     this.addEventListener('click', (e) => {
//       const countryLink = e.target.closest('a');
//       if (countryLink) this.handleCountryClick(e, countryLink);
//     });
//   }

//   handleCountryClick(event, countryLink) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     const value = countryLink.dataset.value;

//     if (this.input && value) {
//       this.input.value = value;
//       form?.submit();
//     }
//   }

//   normalize(str) {
//     return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
//   }

//   findCountrie() {
//     const searchValue = this.normalize(this.searchInput?.value || '');
//     const countryLinks = this.querySelectorAll('a');

//     this.resetButton?.classList.toggle('hidden', !searchValue);
//     this.searchIcon?.classList.toggle('hidden', !!searchValue);

//     countryLinks.forEach(link => {
//       const countryName = this.normalize(link.querySelector('.country')?.textContent || '');
//       const isMatch = countryName.includes(searchValue);
//       link.parentElement.classList.toggle('hidden', !isMatch);
//     });
//   }

//   resetFilter(event) {
//     event.stopPropagation();
//     if (!this.searchInput) return;
//     this.searchInput.value = '';
//     this.findCountrie();
//     this.searchInput.focus();
//   }

//   preventEnterSubmit(event) {
//     if (event.code === 'Enter') event.preventDefault();
//   }
// }

// customElements.define('localization-form', LocalizationForm);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      search: this.querySelector('input[name="country_filter"]'),
      resetButton: this.querySelector('.country-filter-reset-button'),
      searchIcon: this.querySelector('.country-filter-search-icon'),
    };
    
    this.querySelectorAll('a').forEach(item => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });

    this.initializeFilter();
  }

  initializeFilter() {
    const { search, resetButton } = this.elements;
    const countryLinks = [...this.querySelectorAll('a')];

    if (!search) return;

    countryLinks.forEach(link => {
      const name = link.querySelector('.country')?.textContent?.trim() || '';
      link.dataset.normalized = this.normalizeString(name);
    });

    search.addEventListener('input', () => {
      const term = this.normalizeString(search.value);

      resetButton?.classList.toggle('hidden', !term);
      this.elements.searchIcon?.classList.toggle('hidden', !!term);

      countryLinks.forEach(link => {
        const match = link.dataset.normalized.includes(term);
        link.parentElement.classList.toggle('hidden', !match);
      });
    });

    resetButton?.addEventListener('click', e => {
      e.stopPropagation();
      search.value = '';
      countryLinks.forEach(link => link.parentElement.classList.remove('hidden'));
      resetButton.classList.add('hidden');
      this.elements.searchIcon?.classList.remove('hidden');
      search.focus();
    });

    resetButton?.addEventListener('mousedown', e => e.preventDefault());
  }

  normalizeString(str) {
    return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
  }

  // onItemClick(event) {
  //   event.preventDefault();
  //   const form = this.querySelector('form');
  //   this.elements.input.value = event.currentTarget.dataset.value;
  //   if (form) form.submit();
  // }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const target = event.currentTarget.dataset.target;
    const input = this.querySelector(`input[name="${target}"]`);

    input.value = event.currentTarget.dataset.value;
    form?.submit();
  }

}

customElements.define('localization-form', LocalizationForm);